module.exports = __webpack_public_path__ + "img/Feature.36bc9c0b.png";